var map = {
	"./apt_icon.png": "cRdT",
	"./close.png": "hSZV",
	"./delete.png": "ty0o",
	"./document_bleu.png": "sePA",
	"./doucment_bleu.png": "Vbg4",
	"./edit.png": "QVuj",
	"./electricity.png": "S8/e",
	"./glaziery.png": "B7lW",
	"./heating.png": "KDzd",
	"./householdappliance.png": "lt1c",
	"./immeuble_icon.png": "VRuu",
	"./membres.png": "jqdf",
	"./message.png": "EHIH",
	"./newticket.png": "b7NU",
	"./other.png": "tTmU",
	"./phone.png": "NOPw",
	"./photo.png": "CHdE",
	"./plumbing.png": "ZSPz",
	"./signature.png": "AqN0",
	"./stats.png": "8Eqn",
	"./time.png": "Vg0P",
	"./video.png": "vtX3"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "akfz";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon nonrecursive \.(png|svg)$
// module id = akfz
// module chunks = 0